exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-red[data-v-5b0ad8c8] {\n  color: #c23a3a;\n}\n.cursor-pointer[data-v-5b0ad8c8] {\n  cursor: pointer;\n}\n.role[data-v-5b0ad8c8] {\n  font-size: 14px;\n}", ""]);

// exports
